/**
 * @generated SignedSource<<6a2929a8c890ecdf8960609397a18cb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type damDialogQuery$variables = {
  filterMasks?: string | null;
  sortBy?: string | null;
};
export type damDialogQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"damDialog_fragment">;
};
export type damDialogQuery = {
  response: damDialogQuery$data;
  variables: damDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterMasks"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortBy"
  }
],
v1 = {
  "kind": "Variable",
  "name": "filterMasks",
  "variableName": "filterMasks"
},
v2 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v3 = [
  {
    "kind": "Literal",
    "name": "after",
    "value": "0"
  },
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "title",
    "value": ""
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "damDialogQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "damDialog_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "damDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DamScenesConnection",
        "kind": "LinkedField",
        "name": "damScenes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DamScenesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DamScene",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DamScenesAssets",
                    "kind": "LinkedField",
                    "name": "assets",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DamSceneAsset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DamSceneAssetFile",
                            "kind": "LinkedField",
                            "name": "file",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fileUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnailUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "title",
          "filterMasks",
          "sortBy"
        ],
        "handle": "connection",
        "key": "damDialog_damScenes",
        "kind": "LinkedHandle",
        "name": "damScenes"
      }
    ]
  },
  "params": {
    "cacheID": "ec8f062deb56a55cbeeabd2dbe235403",
    "id": null,
    "metadata": {},
    "name": "damDialogQuery",
    "operationKind": "query",
    "text": "query damDialogQuery(\n  $filterMasks: String\n  $sortBy: String\n) {\n  ...damDialog_fragment_3cz1jI\n}\n\nfragment damDialog_fragment_3cz1jI on Query {\n  damScenes(first: 20, after: \"0\", title: \"\", filterMasks: $filterMasks, sortBy: $sortBy) {\n    edges {\n      node {\n        id\n        title\n        assets {\n          asset {\n            title\n            file {\n              fileUrl\n            }\n            thumbnailUrl\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eefe57daa8680f50abe04069896c61bd";

export default node;
